import {CreateInstance} from './config'
const ApplicationsAPI = CreateInstance('applications')
export default ApplicationsAPI